<template>
  <div :class="'social-media-plan-popup' + (isEdit ? ' is-edit' : '')">

    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-7">
            <div class="field-box"
              v-for="(field, index) in _.filter(deliverableDetail.customFields, { field_key: 'social_media_plan_details' })"
              :key="index">
              <DeliverableCustomFields :deliverable="deliverableDetail" :customField="field" :namespace="namespace" />
            </div>
          </div>
          <div class="col-md-5">
            <div class="row no-gutters">
              <div class="col-md-12">
                <div class="row no-gutters">
                  <div class="col-md-12">
                    <div class="form-group">
                      <div class="tags__wrapper">
                        <DeliverableListTags :deliverable="deliverableDetail" :namespace="namespace"
                          @tag-created="updateDeliverableTags" />
                      </div>
                      <div class="trending-tags" v-if="relatedTags.length">
                        <label class="field-label-tags">Trending tags:</label>
                        <a href="#" @click.prevent="setTag(relatedTag)" class="badge badge-success ml-2"
                          v-for="(relatedTag, index) in relatedTags" :key="'relate-tag' + index">{{ relatedTag.name
                          }}</a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="field-box"
                      v-for="(field, index) in _.filter(deliverableDetail.customFields, { field_key: 'budget' })"
                      :key="index">
                      <DeliverableCustomFields :deliverable="deliverableDetail" :customField="field"
                        :namespace="namespace" />
                    </div>
                  </div>
                  <div class="col-md-6" style="padding-right:10px;">
                    <div class="field-box"
                      v-for="(field, index) in _.filter(deliverableDetail.customFields, { field_key: 'start_date' })"
                      :key="index">
                      <DeliverableCustomFields :deliverable="deliverableDetail" :customField="field"
                        :namespace="namespace" />
                    </div>
                  </div>
                  <div class="col-md-6" style="padding-left:10px;">
                    <div class="field-box"
                      v-for="(field, index) in _.filter(deliverableDetail.customFields, { field_key: 'end_date' })"
                      :key="index">
                      <DeliverableCustomFields :deliverable="deliverableDetail" :customField="field"
                        :namespace="namespace" />
                    </div>
                  </div>

                  <div class="col-md-12 field-box" v-if="hasChat()">
                    <div class="field-header">
                      <div class="field-label">Chat</div>
                    </div>
                    <div class="field-wrap">
                      <div class="chat-wrapper">
                        <Chat 
                          :primaryParticipantId="deliverableDetail.id"
                          :primaryParticipantTitle="deliverableDetail.title"
                          :primaryParticipantType="deliverableDetail.deliverable_template_id"
                          :chatNamespace="'deliverableChat'" :shouldRefreshMessages="isEdit" />
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12 field-box">
                    <div class="field-box__header">
                      <div class="dropdown">
                        <button v-b-tooltip.hover title="Add resource"
                          class="add-resource-button exclude-outside-click d-inline-block" data-toggle="dropdown"
                          aria-expanded="false" data-reference="parent">Resources</button>
                        <plus-button data-toggle="dropdown" aria-expanded="false" data-reference="parent"></plus-button>
                        <div class="dropdown-menu deliverable-resource-type-menu">
                          <a class="dropdown-item" href="#" v-for="(type, i) in optionsForLinkType" :key="i"
                            @click="addResourceMenuItemClick(type, $event)"><img class="link-type-icon"
                              :src="require(`@/csmworkflow/img/${type.icon}`)"> {{ type.name }}</a>
                        </div>
                      </div>
                    </div>
                    <div class="field-box__content">
                      <div class="resource-box"
                        v-for="(resource, index) in _.filter(deliverableDetail.customFields, { field_key: 'link_url' })"
                        :key="'link_url-' + index">
                        <div class="media">
                          <img class="link-type-icon" style="margin-right: 3px"
                            :src="require(`@/csmworkflow/img/${getLinkTypeObject(customChildFieldValue('link_type', resource.id)).icon}`)"
                            draggable="false">
                          <div class="media-body">
                            <div class="resource-box__url"></div>
                            <a v-if="resource.value" :href="resource.value"
                              @click="openCopyLinkModal(resource.value, $event, index)" target="_blank"
                              :id="`resource-${index}`">{{ customChildFieldValue('link_label',
                                resource.id)
                                || resource.value }}</a>
                            <a v-if="!resource.value" :href="getResourceHref(resource.value, resource.id)" target="_blank"
                              :id="`resource-${index}`"
                              @click="setCookieForDownload">{{ customChildFieldValue('link_label', resource.id) ||
                              resource.value}}</a>
                            <b-tooltip :target="`resource-${index}`" noninteractive triggers="manual"><i
                                class="fas fa-check" style="color:#4C9850;"></i> Link Copied!</b-tooltip>
                            <a v-b-tooltip.hover title="Edit resource" class="edit-resource-btn" href="#"
                              v-if="!(!userAbilities.editMediaCall || deliverableDetail.permissions.viewOnly)"
                              @click.prevent="editResource(resource)">

                              <i class="fas fa-edit"></i>
                            </a>
                            <div class="resource-box__notes" v-if="customChildFieldValue('link_notes', resource.id)">
                              {{ customChildFieldValue('link_notes', resource.id) }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal centered no-close-on-backdrop hide-footer id="createLinkModal" title="New Resource / Link" @shown="focusLinkModal">
      <CreateLinkModal ref="refLinkModal" v-bind:link-url="linkUrl" v-bind:link-label="linkLabel"
        v-bind:link-notes="linkNotes" v-bind:link-type="linkType" :is-file="editLinkIsFile"
        :resource-parent="'deliverable'" :namespace="namespace" />
    </b-modal>
    <b-modal centered no-close-on-backdrop hide-footer id="editLinkModal" title="Update Resource / Link" @shown="focusEditLinkModal">
      <EditLinkModal ref="refEditLinkModal" v-bind:link-url="linkUrl" v-bind:link-label="linkLabel"
        v-bind:link-notes="linkNotes" v-bind:link-type="linkType" v-bind:is-file="editLinkIsFile"
        :namespace="namespace" />
    </b-modal>
    <b-modal centered id="linkCopyLinkModal" title="Copy Link" ok-only ok-title="Done">
      <LinkCopyLinkModal :linkUrl="linkCopyModalValue" :namespace="namespace" />
    </b-modal>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import { mapActions, mapGetters, mapState } from "vuex";
import DeliverableCustomFields from "../common/DeliverableCustomField";
import LinkCopyLinkModal from "../common/LinkCopyLinkModal.vue";
import Chat from "./Chat.vue";
import CreateLinkModal from "./CreateLinkModal";
import DeliverableListTags from "./DeliverableListTags";
import EditLinkModal from "./EditLinkModal";

export default {
  props: ['isEdit', 'deliverableDetail', 'hideTitle', 'namespace'],
  components: {
    'vuejs-datepicker': Datepicker,
    Chat,
    CreateLinkModal,
    EditLinkModal,
    LinkCopyLinkModal,
    DeliverableCustomFields,
    DeliverableListTags,
  },
  data() {
    return {
      linkUrl: null,
      linkLabel: null,
      linkNotes: null,
      linkType: null,
      editLinkIsFile: false,
      linkCopyModalValue: "",

    }
  },
  computed: {
    ...mapGetters([
      "userAbilities",
    ]),
    ...mapState({
      state(state) {
        return state[this.namespace]
      },
      allCustomFields(state, getters) {
        return getters[this.namespace + 'allCustomFields']
      },
    }),
    relatedTags() {
      let trendingTags = this.$store.state.deliverables.trendingTags;
      if (typeof this.deliverableDetail.tags != "undefined") {
        this.deliverableDetail.tags.forEach(deliverableTag => {
          trendingTags = _.reject(trendingTags, function (e) {
            return e.id == deliverableTag.id;
          });
        });
      }
      return trendingTags;
    },
    apiUrl() {
      return process.env.MIX_API_BASE_URL;
    },
    optionsForLinkType() {
      let linkTypeField = this.allCustomFields.find(x => x.id == 37);
      if (!linkTypeField) {
        this.$store.dispatch(this.namespace + "fetchAllCustomFields");
      } else {
        return JSON.parse(linkTypeField.value_set);
      }
    },
    _() {
      return _;
    },

  },
  methods: {
    ...mapActions({
      updateFieldValue(dispatch, payload) {
        return dispatch(this.namespace + 'updateFieldValue', payload)
      },
    }),
    hasChat() {
      let contactCustomFields = _.filter(this.deliverableDetail.templateCustomFields, { field_type: 'chat' });
      if (Array.isArray(contactCustomFields) && contactCustomFields.length) {
        // array exist, is not empty
        return true;
      }
    },

    setTag(newTag) {
      if (!this.userAbilities.editMediaCall || this.deliverableDetail.permissions.viewOnly) return;
      this.deliverableDetail.tags.push(newTag);
      this.$store.dispatch(this.namespace + "updateFieldValue", this.deliverableDetail);
    },

    updateDeliverableTags() {
      //update listing when modal is opened on top
      this.$store.dispatch(this.namespace + "updateFieldValue", this.deliverableDetail);
    },

    budgetClick() {
      this.budgetEditing = true;
      setTimeout(() => {
        this.$refs.budgetInput.select();
      }, 100);
    },
    budgetClickOutside() {
      this.budgetEditing = false;
    },
    customChildField(key, parent_id) {
      if (this.deliverableDetail.customFields) {
        let obj = _.filter(this.deliverableDetail.customFields, { field_key: key, parent_id: parent_id });
        if (obj.length > 0) {
          // lets add it to the
          return obj;
        } else {
          let field = _.filter(this.allCustomFields, { field_key: key });
          // this breaks, its always undefined because customFields is an indexed array?
          if (typeof this.deliverableDetail.customFields[key] == "undefined") {
            return null;
          } else {
            obj = {};
            obj.id = null;
            obj.parent_id = this.deliverableDetail.customFields[key].id;
            obj.deliverable_id = this.deliverableDetail.customFields[key].deliverable_id;
            obj.editing = false;
            obj.field_id = field[0].id;
            obj.field_key = field[0].field_key;
            obj.field_parent_id = field[0].parent_id;
            obj.field_type = field[0].field_type;
            obj.note = field[0].note;
            obj.value = null;
            obj.label = field[0].label;
            obj.value_set = field[0].value_set;
            obj.updated_at = this.deliverableDetail.customFields[key].updated_at;
          }
          return [obj];
        }
      }
      return [];
    },

    customChildFieldValue(key, parent_id) {
      if (this.deliverableDetail.customFields) {
        let obj = _.filter(this.deliverableDetail.customFields, { field_key: key, parent_id: parent_id });
        if (obj != null) {
          if (obj.length > 0) {
            return obj[0].value;
          } else {
            return null;
          }
        }
      }
      return null;
    },

    // Resources

    editResource(resource) {
      this.linkUrl = resource;
      let label = this.customChildField('link_label', resource.id);
      if (label.length > 0) {
        this.linkLabel = label[0];
      } else {
        this.linkLabel = {};
      }
      let notes = this.customChildField('link_notes', resource.id);
      if (notes.length > 0) {
        this.linkNotes = notes[0];
      } else {
        this.linkNotes = {};
      }
      let type = this.customChildField('link_type', resource.id);
      if (type && type.length > 0) {
        this.linkType = type[0];
      } else {
        this.linkType = {
          id: null,
          field_id: 37,
          parent_field_id: 20,
          field_key: "link_type",
          field_type: "select",
          parent_id: null,
          deliverable_id: this.deliverableDetail.deliverableId,
          value: 1
        };
      }
      let fileId = this.customChildField('file_id', resource.id);
      this.editLinkIsFile = Boolean(fileId);
      this.$bvModal.show("editLinkModal");
    },

    addResource(typeId = 1, modalId) {
      if (!this.userAbilities.editMediaCall || this.deliverableDetail.permissions.viewOnly) return;
      this.linkUrl = {
        id: null,
        field_id: 20,
        parent_field_id: null,
        field_key: "link_url",
        field_type: "text",
        parent_id: null,
        deliverable_id: this.deliverableDetail.deliverableId,
        value: null
      };
      this.linkLabel = {
        id: null,
        field_id: 21,
        parent_field_id: 20,
        field_key: "link_label",
        field_type: "text",
        parent_id: null,
        deliverable_id: this.deliverableDetail.deliverableId,
        value: null
      };
      this.linkNotes = {
        id: null,
        field_id: 22,
        parent_field_id: 20,
        field_key: "link_notes",
        field_type: "text",
        parent_id: null,
        deliverable_id: this.deliverableDetail.deliverableId,
        value: null
      };
      this.linkType = {
        id: null,
        field_id: 37,
        parent_field_id: 20,
        field_key: "link_type",
        field_type: "select",
        parent_id: null,
        deliverable_id: this.deliverableDetail.deliverableId,
        value: typeId
      };
      this.$bvModal.show(modalId);
    },
    addResourceMenuItemClick(type, e) {
      e.preventDefault();
      let modalId = "createLinkModal";
      if (type.slug == "file") {
        this.editLinkIsFile = true;
      } else {
        this.editLinkIsFile = false;
      }
      this.addResource(type.id, modalId);
    },

    focusLinkModal() {
      this.$refs.refLinkModal.focusMyElement();
    },
    focusEditLinkModal() {
      this.$refs.refEditLinkModal.focusMyElement();
    },

    getLinkTypeObject(id) {
      if (id == null) id = 1;
      const r = this.optionsForLinkType.find(x => x.id == id);
      return r;
    },
    setCookieForDownload() {
      this.$store.dispatch("setUserAuthCookie");
    },
    getResourceHref(url, parent_id) {
      let label = this.customChildFieldValue('link_label', parent_id);
      let fileId = this.customChildFieldValue('file_id', parent_id);
      if (url == null && fileId != null && label) {
        return `${this.apiUrl}downloadFileDeliverable/${this.deliverableDetail.id}/${fileId}`;
      }
      return "";
    },

    openCopyLinkModal(link, e, i) {
      if (!link.includes("\\")) {
        return;
      }
      e.preventDefault();
      this.copyLink(link, i);
    },
    async copyLink(link, resourceId) {
      clearTimeout(this.linkCopyLinkTimeouts[resourceId]);
      Object.keys(this._.filter(this.deliverableDetail.customFields, { field_key: 'link_url' })).forEach(x => {
        if (x == resourceId) return;
        this.$root.$emit('bv::hide::tooltip', 'resource-' + x);
      })

      const navPer = await navigator.permissions.query({ name: "clipboard-write" });
      if (navPer.state == "granted" || navPer.state == "prompt") {
        try {
          await navigator.clipboard.writeText(link);
        } catch {
          console.error("clipboard API error. Cannot copy to clipboard.");
          this.legacyCopyMethod(link);
        }
      } else {
        this.legacyCopyMethod(link);
      }

      this.$root.$emit('bv::show::tooltip', 'resource-' + resourceId);
      this.linkCopyLinkTimeouts[resourceId] = setTimeout(() => {
        this.$root.$emit('bv::hide::tooltip', 'resource-' + resourceId);
      }, 2000);
    },

  },
}
</script>
<style scoped>
.social-media-plan-popup .field-box {
  margin-top: 16px;
}

.social-media-plan-popup {
  margin-left: 0px;
}
</style>